module.exports = __webpack_public_path__ + "media/customizations/woodforest/back-3baac29109088cc19f9762db25a897cf.jpg";